// 客户拜访管理模块-埋点配置
const config = {
    'customerVisitManage': {
        'bigData-btn-customer-visit-list-import': '客户模块,重点客户分级管理,,导入',
        'bigData-btn-customer-visit-list-batch-enable': '客户模块,重点客户分级管理,,批量启用任务',
        'bigData-btn-customer-visit-list-delete': '客户模块,重点客户分级管理,,删除任务',
        'bigData-btn-customer-visit-list-export': '客户模块,重点客户分级管理,,导出'
    }
};

export default config;
